/**
 * @generated SignedSource<<d7c6927d121ca6a3c01f8706dcfffcd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExternalComplaint_query$data = {
  readonly company: {
    readonly " $fragmentSpreads": FragmentRefs<"Brand_company" | "ExternalComplaintForm_company">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ExternalComplaintForm_query">;
  readonly " $fragmentType": "ExternalComplaint_query";
};
export type ExternalComplaint_query$key = {
  readonly " $data"?: ExternalComplaint_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExternalComplaint_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalComplaint_query",
  "selections": [
    {
      "alias": "company",
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "companyDomainName",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ExternalComplaintForm_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Brand_company"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExternalComplaintForm_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "9a58b24a17869d60a2b30831c293d99a";

export default node;
